class Extranet.Models.Tax extends Extranet.Model

  idAttribute: 'uuid'
  urlRoot: '/v2/getaways/extranet/taxes'
